<template>
  <v-container grid-list-md text-xs-center v-resize="checkMobile">
    <plan-gate service="simple_cashbox" />
    <!-- <loading :active.sync="isLoading" :is-full-page="true" color="#1976d2"
      :background-color="$vuetify.theme.dark ? '#000' : ''"></loading> -->
    <v-card :loading="isLoading">
      <v-card-title>
        <v-row>
          <v-col cols="12" class="text-center">
            <h2 v-if="!isMobile">{{ $t("counts.add_count") }}</h2>
            <h4 v-else>{{ $t("counts.add_count") }}</h4>
          </v-col>
          <v-col cols="12">
            <v-divider></v-divider>
          </v-col>
        </v-row>
      </v-card-title>

      <v-card-text>
        <v-row>
          <v-col cols="12" class="d-flex align-center justify-space-between">
            <v-row>
              <v-col cols="12" lg="4" md="4" sm="12">
                <v-switch v-model="internal_transfer" :disabled="debts_count || isLoading"
                  :label="$t('counts.internal_1')" @change="internal_transfer ? setInternalTransfer() : ''" hide-details
                  dense v-tooltip="{
                    content: $t('tooltips.worker_to_worker'),
                    placement: 'bottom-center',
                    classes: ['info'],
                    targetClasses: ['it-has-a-tooltip'],
                    delay: {
                      show: 500,
                      hide: 500,
                    },
                  }"></v-switch>
              </v-col>
              <v-col cols="12" lg="4" md="4" sm="12">
                <v-switch v-model="debts_count" :disabled="isLoading || internal_transfer" :label="$t('debts.pay')"
                  hide-details dense v-tooltip="{
                    content: $t('tooltips.pay_debt_client'),
                    placement: 'bottom-center',
                    classes: ['info'],
                    targetClasses: ['it-has-a-tooltip'],
                    delay: {
                      show: 500,
                      hide: 500,
                    },
                  }"></v-switch>
              </v-col>
              <v-col cols="12" lg="4" md="4" sm="12">
                <v-switch v-model="count.completed" :disabled="isLoading || internal_transfer"
                  :label="count.completed ? $t('counts.completed') : $t('counts.not_completed')" hide-details dense
                  v-tooltip="{
                    content: $t('tooltips.count_completed'),
                    placement: 'bottom-center',
                    classes: ['info'],
                    targetClasses: ['it-has-a-tooltip'],
                    delay: {
                      show: 500,
                      hide: 500,
                    },
                  }"></v-switch>
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="12">
            <v-divider></v-divider>
          </v-col>
          <v-col cols="12">
            <v-row>
              <v-col cols="12" sm="3" :md="row_md.sum">
                <v-row align="center">
                  <v-col auto>
                    <v-text-field v-model.number="count.sum" :label="$t('custom.amount')" :disabled="isLoading"
                      :messages="messageInBaseCurrency(count.sum, count.currency_id)" data-testid="new-count-sum"></v-text-field>
                  </v-col>
                  <v-col auto v-if="company && company.multicurrency_cashboxes && !debts_count">
                    <v-select v-model="count.company_cashbox" :items="active_company_cashboxes"
                      :item-text="item => item.name" :return-object="true"
                      @change="count.currency_id = count.company_cashbox.currency_id, count.company_cashbox_id = count.company_cashbox.id"
                      :label="$t('companies.currency')" :disabled="isLoading" data-testid="new-count-cashbox"></v-select>
                  </v-col>
                </v-row>
              </v-col>
              <v-col cols="12" sm="3" :md="row_md.group" v-if="!internal_transfer">
                <v-autocomplete v-model="selected_count"
                  :item-text="item => translateCategory(item.value)" item-value="value" :items="counts_categories"
                  :label="$t('custom.select_group')" :disabled="isLoading" data-testid="new-count-group">
                  <template v-slot:item="{ item }">
                    <v-list-item-icon class="mr-2">
                      <v-icon v-if="!isFormModeCategory(item)" :color="getOperationTypeColor(isIncomeCategory(item))">
                        {{ getOperationTypeIcon(isIncomeCategory(item)) }}
                      </v-icon>
                      <v-icon v-else color="warning">mdi-arrow-up-down</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                      <v-list-item-title>{{ translateCategory(item.value) }}</v-list-item-title>
                    </v-list-item-content>
                  </template>
                </v-autocomplete>
              </v-col>
              <v-col cols="12" sm="3" :md="row_md.subcategory" v-if="show_subcategory">
                <v-autocomplete v-model="selected_subcategory" :items="subcategory_options" item-text="value"
                  item-value="id" :label="$t('counts.subcategory')" clearable :disabled="isLoading"
                  data-testid="new-count-subcategory"></v-autocomplete>
              </v-col>
              <v-col cols="12" sm="3" :md="row_md.object" v-if="!internal_transfer && !debts_count">
                <v-autocomplete v-model="selected_car" item-text="code" item-value="id" text
                  :label="$t('custom.select_car')" :items="cars" :disabled="isLoading"></v-autocomplete>
              </v-col>
              <v-col cols="12" sm="3" md="3" v-if="internal_transfer">
                <v-autocomplete v-model="selected_user" item-text="name" item-value="id" text
                  :label="$t('other.select_worker')" :items="workers_names" :disabled="isLoading"></v-autocomplete>
              </v-col>
              <v-col cols="12" sm="3" md="3" v-if="debts_count">
                <v-autocomplete v-model="selected_debt" item-text="text_id" item-value="id" type="text"
                  :loading="isLoadingDebts" :search-input.sync="search_debt" flat :label="$t('tooltips.number_debt')"
                  :items="debts" :disabled="isLoading"></v-autocomplete>
              </v-col>

              <v-col cols="12" sm="3" :md="row_md.operation" class="d-flex align-center justify-space-between">
                <v-radio-group v-model="count.operation" row class="justify-center mx-auto" data-testid="new-count-operation">
                  <v-radio :label="$t('custom.income')" :value="true" @change="operationCheck = true"
                    :disabled="operation_locked_by_category || isLoading" data-testid="new-count-income"></v-radio>
                  <v-radio :label="$t('custom.expences')" :value="false"
                    :disabled="operation_locked_by_category || internal_transfer || debts_count || isLoading"
                    @change="operationCheck = true" data-testid="new-count-expense"></v-radio>
                </v-radio-group>
              </v-col>
              <v-col cols="12" sm="12" md="12"
                :class="!isMobile ? 'd-flex align-center justify-space-between' : 'd-flex align-center justify-space-between pl-1'">
                <v-checkbox v-if="company && company.cash_payment" v-model="count.cash"
                  :disabled="count.cashless || count.cash_card || count.entity || count.client_balance || isLoading"
                  class="mt-0 mr-1" dense hide-details :style="count.cashless || count.cash_card || count.entity || count.client_balance
                    ? 'opacity: 0.4;'
                    : ''
                    " data-testid="new-count-cash">
                  <template v-slot:label>
                    <v-icon class="text-center mr-1" color="success" size="30">
                      mdi-cash
                    </v-icon>
                    <span v-if="!isMobile">{{ $t("money.cash") }}</span>
                  </template>
                </v-checkbox>
                <v-checkbox v-if="company && company.cashless_payment" v-model="count.cashless"
                  :label="$t('money.terminal')" :disabled="count.cash ||
                    count.cash_card ||
                    count.entity ||
                    count.client_balance ||
                    internal_transfer ||
                    isLoading
                    " class="mt-0 mr-1" dense hide-details data-testid="new-count-cashless" :style="count.cash ||
                      count.cash_card ||
                      count.entity ||
                      count.client_balance ||
                      internal_transfer ||
                      isLoading
                      ? 'opacity: 0.4;'
                      : ''
                      " v-tooltip="{
                        content: $t('tooltips.terminal_count'),
                        placement: 'bottom-center',
                        classes: ['info'],
                        targetClasses: ['it-has-a-tooltip'],
                        delay: {
                          show: 500,
                          hide: 500,
                        },
                      }">
                  <template v-slot:label>
                    <v-icon class="text-center mr-1" color="warning">
                      mdi-contactless-payment-circle-outline
                    </v-icon>
                    <span v-if="!isMobile">{{ $t("money.terminal") }}</span>
                  </template>
                </v-checkbox>
                <v-checkbox v-if="company && company.card_to_card_payment" v-model="count.cash_card" data-testid="new-count-cash-card" :disabled="count.cash ||
                  count.cashless ||
                  count.entity ||
                  count.client_balance ||
                  internal_transfer
                  " class="mt-0 mr-1" dense hide-details :style="count.cash ||
                    count.cashless ||
                    count.entity ||
                    count.client_balance ||
                    internal_transfer ||
                    isLoading
                    ? 'opacity: 0.4;'
                    : ''
                    " v-tooltip="{
                      content: $t('money.card_to_card_2'),
                      placement: 'bottom-center',
                      classes: ['info'],
                      targetClasses: ['it-has-a-tooltip'],
                      delay: {
                        show: 500,
                        hide: 500,
                      },
                    }">
                  <template v-slot:label>
                    <v-icon class="text-center mr-1" color="info">
                      mdi-credit-card-check-outline
                    </v-icon>
                    <span v-if="!isMobile">{{ $t("money.to_card") }}</span>
                  </template>
                </v-checkbox>
                <v-checkbox v-if="company && company.entity_payment" v-model="count.entity" data-testid="new-count-entity"
                  :label="$t('money.to_entity_short')" class="mt-0 mr-1" dense hide-details :disabled="count.cashless ||
                    count.cash_card ||
                    count.cash ||
                    count.client_balance ||
                    internal_transfer ||
                    isLoading
                    " :style="count.cashless ||
                      count.cash_card ||
                      count.cash ||
                      count.client_balance ||
                      internal_transfer
                      ? 'opacity: 0.4;'
                      : ''
                      " v-tooltip="{
                        content: $t('money.from_entity_2'),
                        placement: 'bottom-center',
                        classes: ['info'],
                        targetClasses: ['it-has-a-tooltip'],
                        delay: {
                          show: 500,
                          hide: 500,
                        },
                      }">
                  <template v-slot:label>
                    <v-icon class="text-center mr-1" color="secondery">
                      mdi-bank
                    </v-icon>
                    <span v-if="!isMobile">{{ $t("money.to_entity") }}</span>
                  </template>
                </v-checkbox>
                <v-checkbox v-if="company && company.client_payment && !count.operation" v-model="count.client_balance" data-testid="new-count-client-balance"
                  color="error" class="mt-0 mr-0" dense hide-details :disabled="count.cashless ||
                    count.cash_card ||
                    count.cash ||
                    count.entity ||
                    internal_transfer ||
                    isLoading
                    " :style="count.cashless ||
                      count.cash_card ||
                      count.entity ||
                      count.cash ||
                      internal_transfer
                      ? 'opacity: 0.4;'
                      : ''
                      " v-tooltip="{
                        content: $t('money.client_balance'),
                        placement: 'bottom-center',
                        classes: ['info'],
                        targetClasses: ['it-has-a-tooltip'],
                        delay: {
                          show: 500,
                          hide: 500,
                        },
                      }">
                  <template v-slot:label>
                    <v-icon class="text-center mr-1" color="error">
                      mdi-account-arrow-right
                    </v-icon>
                    <span v-if="!isMobile">{{ $t("money.client_balance") }}</span>
                  </template>
                </v-checkbox>
              </v-col>
              <v-col cols="12" sm="12" md="12"
                v-if="count.cashless || count.cash_card || count.cash || count.entity || count.client_balance"
                class="text-center">
                {{ $t("money.payment_type") }}:
                <span v-if="count.cash">{{ $t("money.cash") }}</span>
                <span v-if="count.cashless">{{ $t("money.terminal") }}</span>
                <span v-if="count.cash_card">{{ $t("money.card_to_card") }}</span>
                <span v-if="count.entity">{{ $t("money.to_entity") }}</span>
                <span v-if="count.client_balance">{{ $t("money.client_balance") }}</span>
              </v-col>
              <v-col cols="12" sm="12" md="12" v-if="count.client_balance">
                <v-autocomplete v-model="count.client_balance_id" item-text="fullname" item-value="id"
                  :disabled="isLoading" :loading="isLoadingClients" :search-input.sync="search_client" clearable
                  hide-no-data hide-details :label="$t('bookings.select_client')" :items="clients">
                </v-autocomplete>
              </v-col>
              <v-col cols="12" sm="12" md="12" v-if="!internal_transfer">
                <v-autocomplete v-model="contractor" item-text="short_name" :items="contractors" :disabled="isLoading"
                  :label="$t('contractors.select_contractor')" hide-no-data hide-details return-object
                  clearable></v-autocomplete>
              </v-col>
              <v-col cols="12" sm="12" md="12">
                <v-textarea v-model="count.description" auto-grow rows="1" :disabled="isLoading"
                  :label="$t('counts.count_description')"
                  :placeholder="$t('counts.count_description_plc')" data-testid="new-count-description"></v-textarea>
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="12" class="text-center">
            <v-btn v-if="!internal_transfer" large color="success" @click="submit()" :loading="isLoading" data-testid="new-count-save">{{
              $t("custom.save")
            }}</v-btn>
            <v-btn v-else large color="success" @click="submitInternalTransfer()" :loading="isLoading">{{
              $t("custom.save")
            }}</v-btn>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import {
  categoryKind,
  companyCountCategories,
  hiddenCategoryCodes,
  isExpenseCategory,
  manualCategories,
  subcategoriesFor,
  translateCountCategory,
} from "@/utils/countCategory";
import moment from "moment";
import { phoneLastDigits } from "@/lib/phone/display";
export default {
  data() {
    return {
      count: {
        group: "",
        operation: null,
        description: "",
        car_id: "",
        sum: 0,
        cash: false,
        cashless: false,
        cash_card: false,
        entity: false,
        contractor_id: null,
        completed: true,
        company_cashbox_id: null,
        currency_id: null,
        client_balance: false,
      },
      company_cashbox_id: null,
      showSelectWorkerCashbox: false,
      internal_transfer: false,
      selected_debt: null,
      debts: [],
      isLoadingDebts: false,
      search_debt: null,
      debtsTimeout: null,
      // Дебаунс отменяет только неотправленный таймер, а улетевший запрос — нет:
      // ответ по старой строке, пришедший последним, подменил бы содержимое
      // выпадашки, не совпадающее с тем, что набрано.
      debtsRequestSeq: 0,
      debts_count: false,
      operationCheck: false,
      selected_count: "",
      // FT-192: необязательная подкатегория выбранной статьи (id), null — не выбрана
      selected_subcategory: null,
      selected_car: "",
      selected_user: "",
      cars: [],
      contractors: [],
      clients: [],
      search_client: null,
      client_balance_id: {},
      contractor: {},
      workers_names: [],
      isMobile: false,
      isLoading: true,
      isLoadingSubscribeToPaidTariff: false,
      isLoadingClients: false,
      timeout: null,
      error: "",
    };
  },
  created() {
    let self = this;
    if (this.$store.getters.isLoggedIn) {
      this.isLoading = true;
      this.axios
        .get("/api/v1/index_for_add_count", {
          headers: {
            Authorization: this.$store.getters.getAuthToken,
          },
        })
        .then((response) => {
          this.cars = response.data.cars;
          this.contractors = response.data.contractors;
          if (this.base_currency_id && this.active_company_cashboxes && this.active_company_cashboxes.length > 0) {
            this.count.currency_id = this.base_currency_id;
            this.count.company_cashbox = this.active_company_cashboxes.find((cashbox) => cashbox.is_default);
            this.count.company_cashbox_id = this.count.company_cashbox.id;
          }
        })
        .catch((error) => {
          this.setError(error, this.$t("errors.cars_load"));
          console.log(error);
        })
        .finally(() => (this.isLoading = false));
    } else {
      this.$store.commit("unsetCurrentUser");
    }
  },
  watch: {
    company_cashbox_id(value) {
      // если есть company_cashbox_id, то ставим id валюты
      if (value) {
        this.count.company_cashbox_id = value;
        let cashbox = this.active_company_cashboxes.find(
          (cashbox) => cashbox.id == value
        );
        this.count.currency_id = cashbox.currency_id;
      } else {
        if (this.active_company_cashboxes.length > 0) {
          this.count.company_cashbox_id = this.active_company_cashboxes[0].id;
          this.count.currency_id = this.active_company_cashboxes[0].currency_id;
        }
      }
    },
    selected_count() {
      // Подкатегория принадлежит статье: при смене статьи сбрасывается.
      this.selected_subcategory = null;
      // Выбор доходной или расходной операции
      if (this.selected_count != "") {
        // Если выбрана категория "Внутренние переводы", запускаем логику как для internal_transfer
        if (this.selected_count == "Внутренние переводы") {
          if (!this.internal_transfer) {
            this.internal_transfer = true;
            this.setInternalTransfer();
          }
        } else {
          // FT-192: доход или расход — по operation_type статьи (для запасного списка —
          // по таблице кодов). «Залог» и неопределяемый тип остаются доходом, как было.
          this.count.operation = isExpenseCategory(this.selected_category) !== true;
          this.operationCheck = true;
        }
      }
    },
    // Серверный поиск. Раньше первый же набор символа грузил ВСЕ долги компании
    // за всю историю одним запросом и потом фильтровал их в браузере — у крупных
    // клиентов это 550 записей и 1667 SQL на открытие выпадашки.
    search_debt(val) {
      // Значение уже выбрано: v-autocomplete кладёт его текст обратно в
      // search-input, перезапрашивать по нему нечего.
      if (this.selected_debt && this.debts.some((debt) => debt.id == this.selected_debt && debt.text_id == val)) {
        return;
      }

      let self = this;
      if (this.debtsTimeout) clearTimeout(this.debtsTimeout);
      this.debtsTimeout = setTimeout(() => {
        self.loadDebts(val);
      }, 300);
    },
    search_client() {
      if (this.search_client == "" || this.search_client == " ") {
        this.search_client = null;
        return;
      } else {
        let self = this;
        function debounce() {
          if (self.timeout) clearTimeout(self.timeout);

          self.timeout = setTimeout(() => {
            // your action
            self.loadClients();
          }, 200); // delay
        }
        debounce();
      }
    },
  },
  computed: {
    userMustChangeTariffPlan() {
      if (this.$store.getters.getMainCompany) {
        if (this.$store.getters.getMainCompany.plan && this.$store.getters.getMainCompany.plan.id) {
          if (this.$store.getters.getMainCompany.plan.name == "Старт" || this.$store.getters.getMainCompany.plan.name == "Start") {
            if (this.$store.getters.getMainCompany.plan.trial_end && moment(this.$store.getters.getMainCompany.plan.trial_end).isAfter(moment())) {
              return false;
            } else {
              return true;
            }
          } else {
            return false;
          }
        } else {
          return false
        }
      } else {
        return false;
      }
    },
    worker_accounts() {
      if (this.$store.getters.getCurrentUser) {
        return this.$store.getters.getCurrentUser.currency_accounts;
      } else {
        return [];
      }
    },
    company() {
      return this.$store.getters.getCompany.company;
    },
    // Статьи компании как пришли с сервера; у филиала без строк — запасной список
    // (31 значение с code/kind/operation_type, чтобы фильтр и тип работали так же).
    categories_source() {
      return companyCountCategories(this.$store.getters.getCompany, { fallback: true });
    },
    // Статьи для ручного выбора: без system, скрытых и скрытых компанией; в режиме
    // оплаты долга скрытие не действует (FT-192 REQ-05).
    counts_categories() {
      return manualCategories(this.categories_source, {
        hiddenCodes: hiddenCategoryCodes(this.$store.getters.getMainCompany),
        debtMode: this.debts_count,
      });
    },
    // Статья, выбранная в форме (с подкатегориями и типом), null — не выбрана или не найдена.
    selected_category() {
      return this.categories_source.find((category) => category && category.value === this.selected_count) || null;
    },
    subcategory_options() {
      return subcategoriesFor(this.selected_category);
    },
    show_subcategory() {
      return !this.debts_count && !this.internal_transfer && this.subcategory_options.length > 0;
    },
    // Доход или расход однозначно задан статьёй — переключатель закрыт; «Залог» и статьи без типа — выбор за пользователем.
    operation_locked_by_category() {
      return !!this.selected_category && isExpenseCategory(this.selected_category) !== null;
    },
    // Ширины первого ряда на десктопе (md+): с подкатегорией в 12 колонок входят пять полей и переключатель
    // «Доходы/Расходы» не уезжает на новую строку; без подкатегории — как до FT-192. Мультикассе сумма шире.
    row_md() {
      if (!this.show_subcategory) return { sum: 3, group: 3, subcategory: 3, object: 3, operation: 3 };
      const multicurrency = !!(this.company && this.company.multicurrency_cashboxes);
      return multicurrency
        ? { sum: 3, group: 2, subcategory: 2, object: 2, operation: 3 }
        : { sum: 2, group: 3, subcategory: 2, object: 2, operation: 3 };
    },
    company_cashboxes() {
      if (this.$store.getters.getCompany && this.$store.getters.getCompany.company && this.$store.getters.getCompany.company.company_cashboxes) {
        let cashboxes = [];
        this.$store.getters.getCompany.company.company_cashboxes.forEach((cashbox) => {
          if (cashbox.id) {
            cashboxes.push(cashbox);
          }
        });
        return cashboxes;
      } else {
        return [];
      }
    },
    active_company_cashboxes() {
      if (this.$store.getters.getCompany && this.$store.getters.getCompany.company && this.$store.getters.getCompany.company.company_cashboxes) {
        let cashboxes = [];
        this.$store.getters.getCompany.company.company_cashboxes.forEach((cashbox) => {
          if (cashbox.id && cashbox.is_active) {
            cashboxes.push(cashbox);
          }
        });
        cashboxes.sort((a, b) => {
          // сортировка по is_default
          if (a.is_default && !b.is_default) {
            return -1;
          }
        });
        return cashboxes;
      } else {
        return [];
      }
    },
    currencies() {
      if (
        this.$store.getters.getCompany &&
        this.$store.getters.getCompany.company &&
        this.$store.getters.getCompany.company.currencies
      ) {
        return this.$store.getters.getCompany.company.currencies;
      } else {
        return [];
      }
    },
    base_currency_id() {
      if (this.active_company_cashboxes && this.active_company_cashboxes.length > 0) {
        return this.active_company_cashboxes.find((cashbox) => cashbox.is_default).currency_id;
      } else {
        return null;
      }
    },
    exchange_rates() {
      if (this.$store.getters.getCompany && this.$store.getters.getCompany.company && this.$store.getters.getCompany.company.exchange_rates) {
        return this.$store.getters.getCompany.company.exchange_rates;
      } else {
        return [];
      }
    },
  },
  methods: {
    loadDebts(search) {
      const seq = ++this.debtsRequestSeq;
      this.isLoadingDebts = true;
      this.axios
        .post(
          "/api/v1/all_debts_v2",
          {
            page: 1,
            per_page: 20,
            sort_by: "id",
            direction: "desc",
            search: search,
          },
          {
            headers: {
              Authorization: this.$store.getters.getAuthToken,
            },
          }
        )
        .then((response) => {
          // Ответ обогнавшего себя запроса выбрасываем: он относится к другой
          // строке поиска.
          if (seq !== this.debtsRequestSeq) return;

          let selected = this.debts.find((debt) => debt.id == this.selected_debt);
          this.debts = response.data.debts.map((debt) => {
            debt["text_id"] = debt.id.toString();
            return debt;
          });
          // Выбранный долг обязан остаться в списке: иначе следующий же набор
          // символов вытеснит его из items, и v-autocomplete покажет пустое поле
          // при непустом v-model.
          if (selected && !this.debts.some((debt) => debt.id == selected.id)) {
            this.debts.unshift(selected);
          }
        })
        .catch((error) => {
          this.setError(error, this.$t("errors.debts_load"));
          console.log(error);
        })
        .finally(() => {
          if (seq === this.debtsRequestSeq) this.isLoadingDebts = false;
        });
    },
    submit() {
      // проверяем на должника
      if (this.$store.getters.getMainCompany && this.$store.getters.getMainCompany.payer_state == 3) {
        this.$notify(this.$t("errors.payer_state_3_title"), this.$t("errors.payer_state_3_text"), "warning", 10000);
        return;
      }
      // /counts/new есть в меню самого агента (Drawer, agents_items), а приём
      // денег определяется настройкой компании, а не ролью — как в
      // BookingCard#savePayment. Голый isStaff ломал агенту его же пункт меню.
      if (this.isStaff || this.agentCan("can_take_money")) {
        // Проверяем что сумма число
        if (isNaN(this.count.sum)) {
          this.$notify(this.$t("errors.count_add"), "", "error");
          return;
        }
        if (this.selected_count == "Внутренние переводы" && (this.selected_user == this.$store.getters.getCurrentUser.id || this.selected_user == "" || this.selected_user == null) ) {
          this.$notify(this.$t("errors.internal_transfer_user_required"), "", "error");
          return;
        }
        if (this.company.multicurrency_cashboxes && this.company.multicurrency_cashboxes == true) {
          // Проверяем если в count.type что платеж наличными
          if (this.count && this.count.type == 'Наличные') {
            // проверяем что у пользователя есть выбранный счёт
            let worker_accounts_cashboxes_ids = this.worker_accounts.map(
              (account) => account.company_cashbox_id
            );
            // получаем все company_cashbox_id из наличного платежа
            let cash_payments_cashbox_ids = [this.count.company_cashbox_id];
            // проверяем, есть ли хотя бы один company_cashbox_id из наличных платежей в worker_accounts_cashboxes_ids
            let has_matching_cashbox = cash_payments_cashbox_ids.some(cashbox_id =>
              worker_accounts_cashboxes_ids.includes(cashbox_id)
            );
            // проверяем есть ли в кассах пользователя касса с такой валютой
            let worker_cashboxes_currency_ids = this.worker_accounts.map((account) => account.currency_id);
            let cash_payments_currency_ids = [this.count.currency_id];
            let has_matching_worker_cashbox_currency = cash_payments_currency_ids.some(cashbox_id =>
              worker_cashboxes_currency_ids.includes(cashbox_id)
            );
            if (has_matching_worker_cashbox_currency) {
              console.log("exists worker_cashbox_currency, select first on server")
            } else {
              console.log("not exists worker_cashbox_currency")
              this.$notify(this.$t("errors.not_exists_worker_currency_account"), "", "error");
              return;
            }
          }
        }
        if (this.count.client_balance && this.count.operation) {
          this.$notify(this.$t("errors.client_balance_only_expences"), this.$t("errors.client_balance_only_expences_text"), "error");
          return;
        }
        if (this.count.client_balance && !this.count.client_balance_id) {
          this.$notify(this.$t("errors.not_enough_data"), "", "error");
          return;
        }
        let self = this;
        if (
          this.selected_count != "" &&
          (this.count.sum > 0 || this.count.sum < 0) &&
          this.operationCheck &&
          (this.count.cash > 0 ||
            this.count.cashless > 0 ||
            this.count.cash_card > 0 ||
            this.count.entity > 0 ||
            this.count.client_balance > 0 ||
            this.count.cash < 0 ||
            this.count.cashless < 0 ||
            this.count.cash_card < 0 ||
            this.count.entity < 0 ||
            this.count.client_balance < 0) &&
          ((this.debts_count && this.selected_debt) ||
            (!this.debts_count && !this.selected_debt))
        ) {
          this.isLoading = true;
          this.axios
            .post(
              "/api/v1/counts",
              {
                counts: {
                  group: this.selected_count,
                  operation: this.count.operation,
                  description: this.count.description,
                  car_id: self.selected_car,
                  sum: parseFloat(this.count.sum.toFixed(2)),
                  cash: this.count.cash,
                  cashless: this.count.cashless,
                  cash_card: this.count.cash_card,
                  entity: this.count.entity,
                  client_balance: this.count.client_balance,
                  client_balance_id: this.count.client_balance ? this.count.client_balance_id : null,
                  contractor_id: self.contractor.id,
                  completed: this.count.completed,
                  company_cashbox_id: this.count.company_cashbox_id,
                  currency_id: this.count.currency_id,
                  debt_id:
                    self.debts_count && self.selected_debt
                      ? self.selected_debt
                      : null,
                  // Ключ передаётся только при выбранной подкатегории (FT-192 REQ-04):
                  // сервер читает «ключ передан» как явное решение.
                  ...(this.show_subcategory && this.selected_subcategory != null
                    ? { counts_subcategory_id: this.selected_subcategory }
                    : {}),
                },
              },
              {
                headers: {
                  Authorization: this.$store.getters.getAuthToken,
                },
              }
            )
            .then(() => {
              this.$router.replace("/counts");
              this.$notify(this.$t("counts.add_payment"), this.$t("counts.add_payment_text"), "success");
            })
            .catch((error) => {
              this.setError(error, this.$t("errors.count_add"));
            })
            .finally(() => (this.isLoading = false));
        } else {
          this.$notify(this.$t("errors.all_fields_title"), "", "warning", 4000);
        }
      } else {
        this.$notify(this.$t("errors.no_access"), "", "warning");
      }
    },
    submitInternalTransfer() {
      // проверяем на должника
      if (this.$store.getters.getMainCompany && this.$store.getters.getMainCompany.payer_state == 3) {
        this.$notify(this.$t("errors.payer_state_3_title"), this.$t("errors.payer_state_3_text"), "warning", 10000);
        return;
      }
      // /counts/new есть в меню самого агента (Drawer, agents_items), а приём
      // денег определяется настройкой компании, а не ролью — как в
      // BookingCard#savePayment. Голый isStaff ломал агенту его же пункт меню.
      if (this.isStaff || this.agentCan("can_take_money")) {
        // Проверяем что сумма число
        if (isNaN(this.count.sum)) {
          this.$notify(this.$t("errors.count_add"), "", "error");
          return;
        }

        if (this.company.multicurrency_cashboxes && this.company.multicurrency_cashboxes == true) {
          // Проверяем если в count.type что платеж наличными
          if (this.count && this.count.type == 'Наличные') {
            // проверяем что у пользователя есть выбранный счёт
            let worker_accounts_cashboxes_ids = this.worker_accounts.map(
              (account) => account.company_cashbox_id
            );
            // получаем все company_cashbox_id из наличного платежа
            let cash_payments_cashbox_ids = [this.count.company_cashbox_id];
            // проверяем, есть ли хотя бы один company_cashbox_id из наличных платежей в worker_accounts_cashboxes_ids
            let has_matching_cashbox = cash_payments_cashbox_ids.some(cashbox_id =>
              worker_accounts_cashboxes_ids.includes(cashbox_id)
            );
            // проверяем есть ли в кассах пользователя касса с такой валютой
            let worker_cashboxes_currency_ids = this.worker_accounts.map((account) => account.currency_id);
            let cash_payments_currency_ids = [this.count.currency_id];
            let has_matching_worker_cashbox_currency = cash_payments_currency_ids.some(cashbox_id =>
              worker_cashboxes_currency_ids.includes(cashbox_id)
            );
            if (has_matching_worker_cashbox_currency) {
              console.log("exists worker_cashbox_currency, select first on server")
            } else {
              console.log("not exists worker_cashbox_currency")
              this.$notify(this.$t("errors.not_exists_worker_currency_account"), "", "error");
              return;
            }
          }
        }

        // Сумма — деньги, а не штуки: копейки допустимы. Прежняя проверка
        // `sum === parseInt(sum, 10)` пропускала только целые, поэтому 100.50 отбивалась
        // с бессмысленным «Ошибка добавления платежа». Точность режется до копеек уже при
        // отправке (toFixed(2) ниже), так что здесь достаточно конечного числа.
        // Обычный платёж этого ограничения не имел никогда — теперь пути совпали.
        if (!Number.isFinite(Number(this.count.sum))) {
          this.$notify(this.$t("errors.count_add"), "", "error");
          return;
        }
        let self = this;
        // Перевод самому себе не операция: обе ноги легли бы на один счёт, два
        // update! затёрли бы друг друга. Сервер отвечает на это 422 — здесь тот же
        // отказ, но своим текстом: раньше стояло all_fields_title и форма с полностью
        // заполненными полями ругалась «Заполнены не все поля».
        if (this.selected_user == this.$store.getters.getCurrentUser.id) {
          this.$notify(
            this.$t("errors.self_transfer_title"),
            this.$t("errors.self_transfer_text"),
            "warning",
            6000
          );
          return;
        }
        // Сумма перевода обязана быть положительной: обе ноги на сервере считаются от
        // одного числа (получателю +sum, отправителю -sum), поэтому минус просто
        // разворачивает перевод, а ноль создаёт пустую пару платежей. Раньше такая сумма
        // падала в общий else и заполненная форма ругалась «Заполнены не все поля».
        if (!(this.count.sum > 0)) {
          this.$notify(
            this.$t("errors.transfer_sum_positive_title"),
            this.$t("errors.transfer_sum_positive_text"),
            "warning",
            6000
          );
          return;
        }
        if (this.selected_user != "") {
          this.isLoading = true;
          let sender = self.workers_names.find(
            (worker) => worker.id == self.selected_user
          );
          this.axios
            .post(
              `/api/v1/create_internal_count?sender_id=${self.selected_user}`,
              {
                counts: {
                  group: self.selected_count,
                  operation: true,
                  description: self.count.description,
                  sum: parseFloat(self.count.sum.toFixed(2)),
                  cash: true,
                  source: sender ? sender.name : "",
                  company_cashbox_id: self.count.company_cashbox_id,
                  currency_id: self.count.currency_id,
                },
              },
              {
                headers: {
                  Authorization: this.$store.getters.getAuthToken,
                },
              }
            )
            .then((response) => {
              this.$router.replace("/counts");
              this.$notify(this.$t("counts.add_payment"), this.$t("counts.add_payment_text"), "success");
            })
            .catch((error) => {
              if (error.response?.data.status == 404) {
                this.$notify(this.$t("errors.count_to_kass"), "", "error");
              } else {
                this.setError(error, this.$t("errors.count_to_kass"));
              }
            })
            .finally(() => (this.isLoading = false));
        } else {
          this.$notify(this.$t("errors.all_fields_title"), "", "warning", 4000);
          return;
        }
      } else {
        this.$notify(this.$t("errors.no_access"), "", "warning");
      }
    },
    setInternalTransfer() {
      this.isLoading = true;
      this.count.cash = true;
      this.count.operation = true;
      this.count.completed = true;
      this.selected_count = "Внутренние переводы";
      this.axios
        .get("/api/v1/get_workers_names_with_ids", {
          headers: {
            Authorization: this.$store.getters.getAuthToken,
          },
        })
        .then((response) => {
          this.workers_names = response.data;
        })
        .catch((error) => {
          this.setError(error, this.$t("errors.employers_load"));
        })
        .finally(() => (this.isLoading = false));
    },
    loadClients() {
      this.isLoadingClients = true;
      this.axios
        .post(
          `/api/v1/index_new_booking_page`,
          {
            search: this.search_client,
            meilisearch: true,
          },
          {
            headers: {
              Authorization: this.$store.getters.getAuthToken,
            },
          }
        )
        .then((response) => {
          this.clients = response.data.query ? response.data.query : (response.data ? response.data : []);
          this.clients.forEach((client) => {
            if (!client.entity) {
              client["fullname"] =
                client.lastname +
                " " +
                client.name +
                " " +
                client.middlename +
                " " +
                (client.phone
                  ? phoneLastDigits(client.phone)
                  : "");
            } else {
              client["fullname"] =
                client.entity_name +
                ", " +
                client.reg_form +
                " " +
                " - " +
                (client.entity_phone
                  ? phoneLastDigits(client.entity_phone)
                  : "");
            }
          });
        })
        .catch((error) => {
          this.setError(error, this.$t("errors.clients_load"));
        })
        .finally(() => (this.isLoadingClients = false));
    },
    sumInBaseCurrency(sum, currency_id) {
      if (this.exchange_rates.length > 0 && currency_id) {
        let exchange_rate = this.exchange_rates.find((exchange_rate) => exchange_rate.target_currency_id == currency_id);
        if (exchange_rate) {
          return (parseFloat(sum) / parseFloat(exchange_rate.rate)).toFixed(2);
        } else {
          return sum / 1;
        }
      } else {
        return sum / 1;
      }
    },
    sumInNonBaseCurrency(sum, currency_id) {
      if (this.exchange_rates.length > 0 && currency_id) {
        let exchange_rate = this.exchange_rates.find((exchange_rate) => exchange_rate.target_currency_id == currency_id);
        if (exchange_rate) {
          return (parseFloat(sum) * parseFloat(exchange_rate.rate)).toFixed(2);
        } else {
          return sum / 1;
        }
      } else {
        return sum / 1;
      }
    },
    messageInBaseCurrency(sum, currency_id) {
      if (sum && currency_id && this.base_currency_id && this.base_currency_id != currency_id) {
        return `${this.sumInBaseCurrency(sum, currency_id)} ${this.findCurrencySymbol(this.base_currency_id)}`;
      } else {
        return '';
      }
    },
    messageInNonBaseCurrency(sum, currency_id) {
      if (sum && currency_id && this.base_currency_id && this.base_currency_id != currency_id) {
        return `${this.sumInNonBaseCurrency(sum, currency_id)} ${this.findCurrencySymbol(currency_id)}`;
      } else {
        return '';
      }
    },
    findCurrencySymbol(id) {
      if (id != null) {
        if (this.currencies.find((currency) => currency.id == id)) {
          return this.currencies.find((currency) => currency.id == id).symbol;
        }
      }
    },
    // Иконка пункта статьи: режим формы («Залог», «Внутренние переводы») — двойная стрелка,
    // доход — вверх, расход и неопределимый тип — вниз.
    isFormModeCategory(category) {
      return categoryKind(category) === "mode";
    },
    // Иконка направления: при operation_type — по нему, как до FT-192 (у старых статей компаний бывает 2/3, это
    // приход, Codex r3); без него (запасной список) — по таблице кодов.
    isIncomeCategory(category) {
      if (category && category.operation_type != null) return Boolean(category.operation_type);
      return isExpenseCategory(category) === false;
    },
    translateCategory(category) {
      return translateCountCategory((key) => this.$t(key), category);
    },
    getOperationTypeColor(type) {
      if (type) {
        return 'success';
      } else {
        return 'error';
      }
    },
    getOperationTypeIcon(type) {
      if (type) {
        return 'mdi-arrow-up';
      } else {
        return 'mdi-arrow-down';
      }
    },
    checkMobile() {
      if (this.$vuetify.breakpoint.name == "xs" || this.$vuetify.breakpoint.name == "sm") {
        this.isMobile = true;
        return true;
      } else {
        this.isMobile = false;
        return false;
      }
    },
    goBack() {
      var numberOfEntries = window.history.length;
      if (numberOfEntries > 2) {
        this.$router.go(-1);
      } else {
        var fpath = this.PageData.backCrumb.url;
        this.$router
          .push({
            path: fpath,
          })
          .catch((err) => { });
      }
    },
  },
};
</script>
